import React from "react"

export default function InfoIcon({ fill = "#fff" }) {
  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.5 3.00171C12.0072 3.00171 3.50168 11.7311 3.50168 22.5C3.50168 33.2689 12.0072 41.9983 22.5 41.9983C32.9928 41.9983 41.4983 33.2689 41.4983 22.5C41.4983 11.7311 32.9928 3.00171 22.5 3.00171ZM25.9485 35.5287C25.9485 35.5287 23.9377 36.165 21.813 35.9448C19.5777 35.7109 19.0549 34.3868 19.0549 33.0488V18.7338C19.0549 18.7338 21.0657 18.0975 23.1904 18.3176C25.4257 18.5515 25.9485 19.8757 25.9485 21.2136V35.5287ZM18.8304 12.7766C18.8304 10.6958 20.4725 9.01044 22.5 9.01044C24.5275 9.01044 26.1696 10.6958 26.1696 12.7766C26.1696 14.8575 24.5275 16.5429 22.5 16.5429C20.4725 16.5429 18.8304 14.8575 18.8304 12.7766Z" fill={fill} />
    </svg>
  )
}
